"use client";
import React from "react";

export const AboutExpertise: React.FC = () => {
  const expertiseAreas = [
    {
      title: "Industrial Product Customization",
      description:
        "We specialize in tailoring high-spec industrial products, including instruments, components, and safety gear, to meet your precise operational requirements and project specifications.",
      icon: (
        <svg
          className="h-10 w-10 text-yellow-600 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
        </svg>
      ),
    },
    {
      title: "Global Sourcing Network",
      description:
        "Leveraging an extensive global network, we efficiently source a diverse range of industrial products, ensuring timely delivery and access to specialized equipment from around the world.",
      icon: (
        <svg
          className="h-10 w-10 text-yellow-600 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684L10.5 9l2.592-5.251a1 1 0 01.948-.684H19a2 2 0 012 2v10a2 2 0 01-2 2h-3.28a1 1 0 01-.948-.684L13.5 15l-2.592 5.251a1 1 0 01-.948.684H5a2 2 0 01-2-2V5z"
          />
        </svg>
      ),
    },
    {
      title: "Technical Support & Consultation",
      description:
        "Beyond distribution, we offer comprehensive technical support and expert consultation to help you select the right products and optimize their performance for your specific applications.",
      icon: (
        <svg
          className="h-10 w-10 text-yellow-600 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M8 14v3m4-3v3m4-3v3M3 21h18M3 10h18M3 7l9-4 9 4M4 10h16v11H4V10z"
          />
        </svg>
      ),
    },
    {
      title: "Supply Chain Optimization",
      description:
        "Our expertise extends to optimizing your supply chain, ensuring efficient logistics, reduced lead times, and reliable delivery of critical industrial components and equipment.",
      icon: (
        <svg
          className="h-10 w-10 text-yellow-600 mb-4"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="2"
            d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.592 1L21 12m-6-4h4m2 4h-4M7 12H3m2-4H1m9 2H6v4h4m-2 4H8"
          />
        </svg>
      ),
    },
  ];

  return (
    <section className="bg-black text-white py-16 md:py-24 lg:py-32">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white mb-4">
            Our Expertise
          </h2>
          <p className="text-lg sm:text-xl text-white leading-relaxed max-w-3xl mx-auto">
            We&apos;re solution providers, not just distributors. We customize
            high-spec industrial products like instruments, components, and safety
            gear to your exact needs.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {expertiseAreas.map((item, index) => (
            <div
              key={index}
              className="bg-black p-6 rounded-lg shadow-md flex flex-col items-start text-center"
            >
              {item.icon}
              <h3 className="text-xl font-semibold text-white mb-2 text-start">
                {item.title}
              </h3>
              <p className="text-white text-start">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AboutExpertise;